import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  MenuItem,
  Alert
} from '@mui/material'
import unifiedApi from '../../utils/unifiedApi'

// ConvertPlaceholderDialog — pick the home and away team and turn a TBD vs TBD
// placeholder into a real game.
const ConvertPlaceholderDialog = ({ open, onClose, onConverted, placeholder, teams = [] }) => {
  const [homeTeamId, setHomeTeamId] = useState('')
  const [awayTeamId, setAwayTeamId] = useState('')
  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)

  // Decision D: info banner explaining the conversion
  const infoMessage = 'Pick the two teams that will play this fixture. The placeholder will be replaced with a regular game in the schedule.'

  useEffect(() => {
    if (open) {
      setHomeTeamId('')
      setAwayTeamId('')
      setError(null)
    }
  }, [open])

  const handleConvert = async () => {
    if (!homeTeamId || !awayTeamId) {
      setError('Both teams are required.')
      return
    }
    if (homeTeamId === awayTeamId) {
      setError('Home and away teams must be different.')
      return
    }
    setSaving(true)
    setError(null)
    try {
      const game = await unifiedApi.convertSchedulePlaceholder(placeholder.id, {
        homeTeamId: Number(homeTeamId),
        awayTeamId: Number(awayTeamId)
      })
      if (onConverted) onConverted(game, placeholder.id)
      onClose()
    } catch (e) {
      setError(e?.message || 'Failed to convert placeholder.')
    } finally {
      setSaving(false)
    }
  }

  if (!placeholder) return null

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Convert Placeholder to Game</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>{infoMessage}</Alert>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            select
            label="Home Team"
            value={homeTeamId}
            onChange={(e) => setHomeTeamId(e.target.value)}
            fullWidth
            required
          >
            {teams.map(t => (
              <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Away Team"
            value={awayTeamId}
            onChange={(e) => setAwayTeamId(e.target.value)}
            fullWidth
            required
          >
            {teams.map(t => (
              <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="contained" onClick={handleConvert} disabled={saving}>
          {saving ? 'Converting…' : 'Convert'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConvertPlaceholderDialog